import { IMenu } from 'components/general/types';
import { SUB_ITEMS, TITLE } from 'config';

export const GEOMETRY = 'geometry';
export const BODY_VECTORS = 'bodyFrameVectors';
export const SURFACES = 'surfaces';
export const FOVS = 'fovs';
export const REFERENCE_VECTORS = 'referenceVectors';

const aTGeometryMenu: IMenu['items'] = {
  [GEOMETRY]: {
    [TITLE]: 'Geometry',
    [SUB_ITEMS]: {
      [BODY_VECTORS]: {
        [TITLE]: 'Body Frame Vectors',
      },
      [SURFACES]: {
        [TITLE]: 'External Surfaces',
      },
      [FOVS]: {
        [TITLE]: 'Fields of View',
      },
      [REFERENCE_VECTORS]: {
        [TITLE]: 'Reference Vectors',
      },
    },
  },
};
export const wGroupIndicesATGeometry = {
  GEOMETRY: `${GEOMETRY}*`,
  BODY_VECTORS: `${GEOMETRY}.${BODY_VECTORS}`,
  SURFACES: `${GEOMETRY}.${SURFACES}`,
  FOVS: `${GEOMETRY}.${FOVS}`,
  REFERENCE_VECTORS: `${GEOMETRY}.${REFERENCE_VECTORS}`,
};

export default aTGeometryMenu;
